import { useQuery } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';

export const HELD_AWAY_INSTITUTIONS_QUERY_KEY = 'heldAwayInstitutions';

export enum HeldAwayInstitutionStatus {
  Good,
  Pending,
  Broken,
}

export interface HeldAwayInstitution {
  itemId: string;
  institutionName: string;
  status: HeldAwayInstitutionStatus;
  lastUpdated: string | null;
}

type HeldAwayInstitutionsDTO = HeldAwayInstitution[];

const fetchHeldAwayInstitutions = async (clientId: string): Promise<HeldAwayInstitutionsDTO> =>
  authFetch(urlWithParams('/Consumer/HeldAwayInstitutions', { clientId }));

export const useDataReconciliationQuery = ({ clientId }) => {
  return useQuery([HELD_AWAY_INSTITUTIONS_QUERY_KEY, clientId], () =>
    fetchHeldAwayInstitutions(clientId),
  );
};
